import { RegexEditor } from '../utils/regex_editor'

const _escape = /^\\([!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~])/
export const escape = new RegexEditor(_escape).replace('])', '~|])').getRegex()
